const AllocationIcon = () => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="27" fill="#E6F1FF" />
      <g clipPath="url(#clip0_3833_28689)">
        <circle cx="32.5" cy="34.5" r="5.9" stroke="#0276FE" strokeWidth="1.2" />
        <path
          d="M30.6247 35.0484L31.858 33.8151L31.858 37.2318C31.858 37.4207 31.9219 37.579 32.0497 37.7068C32.1775 37.8345 32.3358 37.8984 32.5247 37.8984C32.7136 37.8984 32.8719 37.8345 32.9997 37.7068C33.1275 37.579 33.1913 37.4207 33.1913 37.2318L33.1913 33.8151L34.4413 35.0818C34.5747 35.2151 34.733 35.2818 34.9163 35.2818C35.0997 35.2818 35.258 35.2151 35.3913 35.0818C35.5247 34.9484 35.5941 34.7901 35.5997 34.6068C35.6052 34.4234 35.5413 34.2651 35.408 34.1318L32.9913 31.6984C32.8691 31.5762 32.7136 31.5151 32.5247 31.5151C32.3358 31.5151 32.1802 31.5762 32.058 31.6984L29.6747 34.0818C29.5413 34.2151 29.4719 34.3762 29.4663 34.5651C29.4608 34.754 29.5247 34.9151 29.658 35.0484C29.7913 35.1818 29.9525 35.2484 30.1413 35.2484C30.3302 35.2484 30.4913 35.1818 30.6247 35.0484Z"
          fill="#0276FE"
        />
      </g>
      <path
        d="M31.3286 15H15.2529C15.1106 15 15 15.1106 15 15.2529V34.4742"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M24.2469 38.222H18.8409C18.6986 38.222 18.588 38.1113 18.588 37.9691V18.8584C18.588 18.7161 18.6986 18.6055 18.8409 18.6055H34.1105C34.2527 18.6055 34.3634 18.7161 34.3634 18.8584V25.6815"
        stroke="#0276FE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <defs>
        <clipPath id="clip0_3833_28689">
          <rect width="13" height="13" fill="white" transform="translate(26 28)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default AllocationIcon;
